<script lang="ts">
	export let contact
</script>

<div class="contact-banner">
	<div class="icon">
		<img
			title="Contact us"
			src="/images/returns/contact.png"
			alt="
			Contact us"
			height="70px"
			width="70px"
		/>
	</div>

	<p class="lead-1">
		{@html contact}
	</p>
</div>

<style lang="scss">
	.contact-banner {
		padding: 30px 20px;
		background-color: var(--grey);
		display: flex;
		align-items: center;
		gap: 20px;

		@media (min-width: 769px) {
			padding: 30px;
		}

		.icon {
			text-align: center;
			width: 17%;

			img {
				max-width: 100%;
				height: auto;
			}
		}

		p {
			width: calc(83% - 20px);
			font-weight: 700;

			span {
				color: var(--main);
				font-weight: 700;
			}
		}
	}
</style>
